"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolveJobReportScope = void 0;
const tools_1 = require("../../tools");
const types_1 = require("../../types");
const resolveScope_1 = require("../utils/resolveScope");
const utils_1 = require("../utils/utils");
const resolveJobReportScope = (metaExpression, options) => {
    if (metaExpression.scope !== types_1.META_EXPRESSION_SCOPE.JOB_REPORT)
        throw new tools_1.InternalError("MetaExpression Scope not align.");
    if (!options.job_report)
        return (0, utils_1.getMeResultNoResult)();
    return (0, resolveScope_1.resolveScope)(metaExpression, { object: options.job_report });
};
exports.resolveJobReportScope = resolveJobReportScope;
